import ButtonWithIcon from "../../components/Button/Button"
import React from 'react'
import {Grid} from "@mui/material"
import {ReactComponent as NewWindowIcon} from "src/v2/assets/icons/new-windows-icon.svg"
import {ReactComponent as EyeOpenIcon} from "src/v2/assets/icons/eye-open.svg"
import {renderCellDateTime} from "../../../utils/table-render-functions"
import {ReactComponent as TrashIcon} from "src/v2/assets/icons/trash-icon.svg"
import {ReactComponent as ArrowRightIcon} from "src/v2/assets/icons/arrow-right-icon.svg"

const renderDuplicarButton = (params, onVer, onDuplicar) => (
    <Grid container spacing={2}>
        <Grid item>
            <ButtonWithIcon icon={<NewWindowIcon/>} onClick={() => {
                onDuplicar(params.row)
            }}>DUPLICAR</ButtonWithIcon>
        </Grid>
        <Grid item>
            <ButtonWithIcon icon={<EyeOpenIcon/>} onClick={() => onVer?.(params.row)}>VER</ButtonWithIcon>
        </Grid>
    </Grid>
)

export const createColumnsCadastroMotor = (onVer, onDuplicar) => [
    {field: "CETIP", headerName: "CETIP", minWidth: 200, flex: 1},
    {field: "VersaoDocumento", headerName: "VER. DOC", minWidth: 150, flex: 1},
    {
        field: "CriadoEm",
        headerName: "DATA CRIAÇÃO",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => renderCellDateTime(params)
    },
    {field: "Usuario", headerName: "USUÁRIO", minWidth: 200, flex: 1},
    {field: "Status", headerName: "STATUS", minWidth: 200, flex: 1},
    {
        field: "AtualizadoEm",
        headerName: "ÚLTIMA ATUALIZAÇÃO",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => renderCellDateTime(params)
    },
    {
        field: "acoes",
        sortable: false,
        disableColumnMenu: true,
        headerName: "",
        minWidth: 340,
        renderCell: (params) => renderDuplicarButton(params, onVer, onDuplicar),
    },
]


const renderCellStatus = (params) => {
    const {row: {Status}} = params
    const map = {
        READING: "Em andamento",
        ERROR: "Erro na leitura",
        DONE: "Leitura concluída",
    }

    return map[Status] ?? "Status não atribuído"
}

const renderCellActionsOCR = (params, onRegisterOCR, onDeleteOCR) => {
    const {row} = params
    const {Status, ID} = row

    return (
        <Grid container spacing={2}>
            <Grid item>
                <ButtonWithIcon
                    onClick={() => {
                        onDeleteOCR(ID)
                    }}
                    icon={<TrashIcon/>}>
                    EXCLUIR
                </ButtonWithIcon>
            </Grid>
            <Grid item>
                <ButtonWithIcon
                    onClick={() => {
                        onRegisterOCR(ID)
                    }}
                    disabled={Status !== "DONE"}
                    icon={<ArrowRightIcon/>}>
                    CADASTRAR
                </ButtonWithIcon>
            </Grid>
        </Grid>
    )
}

export const createColumnsOCR = (onRegisterOCR, onDeleteOCR) => [
    {field: "CETIP", headerName: "CETIP", minWidth: 200, flex: 1},
    {field: "VersaoDocumento", headerName: "VER. DOC", minWidth: 80, flex: 1},
    {field: "NomeArquivo", headerName: "ARQUIVO", minWidth: 250, flex: 1},
    {field: "Usuario", headerName: "USUÁRIO", minWidth: 200, flex: 1},
    {field: "Status", headerName: "STATUS", minWidth: 200, flex: 1, renderCell: (params) => renderCellStatus(params)},
    {
        field: "CriadoEm",
        headerName: "DATA CRIAÇÃO",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => renderCellDateTime(params)
    },
    {
        field: "acoes",
        sortable: false,
        disableColumnMenu: true,
        headerName: "AÇÕES",
        minWidth: 340,
        renderCell: (params) => renderCellActionsOCR(params, onRegisterOCR, onDeleteOCR)
    },
]